var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 58",
    style: {
      enableBackground: "new 0 0 75 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.28,14.29c-3.84,0-6.96,3.12-6.96,6.96c0,2.06,0.91,3.89,2.34,5.17l-8.78,3.15L40.37,14.7 c2.69-0.96,4.64-3.51,4.64-6.53c0-3.84-3.12-6.96-6.96-6.96c-3.84,0-6.96,3.13-6.96,6.96c0,2.99,1.91,5.53,4.56,6.51L23.13,29.56 l-8.78-3.15c1.42-1.28,2.33-3.11,2.33-5.17c0-3.84-3.12-6.96-6.96-6.96c-3.84,0-6.96,3.12-6.96,6.96c0,3.27,2.28,6,5.32,6.75v18.87 c0,0.13,0.05,0.25,0.08,0.37c-0.05,0.19-0.08,0.39-0.08,0.6c0,6.77,26.86,6.97,29.92,6.97c3.06,0,29.92-0.2,29.92-6.97 c0-0.21-0.03-0.41-0.08-0.6c0.03-0.12,0.08-0.24,0.08-0.37V27.99c3.04-0.75,5.32-3.48,5.32-6.75 C73.23,17.41,70.11,14.29,66.28,14.29z M34.48,8.17c0-1.97,1.61-3.58,3.58-3.58c1.97,0,3.57,1.61,3.57,3.58 c0,1.97-1.6,3.57-3.57,3.57C36.08,11.74,34.48,10.14,34.48,8.17z M23.1,33.16c0.66,0.24,1.41,0.04,1.87-0.51L38,17.14l13.04,15.51 c0.45,0.54,1.2,0.74,1.87,0.51l11.63-4.18v15.26c-7.32-3.26-24.14-3.38-26.53-3.38c-2.39,0-19.21,0.12-26.53,3.38V28.97L23.1,33.16 z M38,51.41c-13.05,0-21.36-1.56-24.81-2.86c-0.68-0.26-1.19-0.51-1.49-0.73c1.08-0.8,4.59-1.89,10.44-2.66 c4.13-0.54,9.41-0.93,15.87-0.93c6.46,0,11.74,0.38,15.87,0.93c5.85,0.77,9.36,1.86,10.44,2.66c-0.3,0.23-0.81,0.47-1.49,0.73 C59.36,49.86,51.05,51.41,38,51.41z M6.16,21.24c0-1.97,1.61-3.57,3.58-3.57c1.97,0,3.57,1.6,3.57,3.57c0,1.97-1.6,3.58-3.57,3.58 S6.16,23.22,6.16,21.24z M66.28,24.82c-1.97,0-3.58-1.61-3.58-3.58c0-1.97,1.61-3.57,3.58-3.57c1.97,0,3.58,1.6,3.58,3.57 C69.85,23.22,68.25,24.82,66.28,24.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.feb2665104832559f0589df462ffe746.svg";
export { ForwardRef as ReactComponent };